export default __webpack_public_path__ + "static/media/100_51338.cbac66f5.jpg";